import Bugsnag from '@bugsnag/js'
import { Box, CircularProgress, Typography, Icon } from '@mui/material'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxTableV2 from 'components/custom/AdxTableV2'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import AdxTableComponent from 'components/reusable/table/AdxTableComponent'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import NoData from 'module/payroll/global-components/NoData'
import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { getHistoryYear, retrieveHistory } from 'services/api/modules/payroll/payroll-history'

const col = [
  {
    id: 1,
    Header: 'Payment period',
    accessor: 'monthYear',
    Cell: (props) => {
      const { value } = props
      return (
        <Box p={2}>
          <Typography>{value}</Typography>
        </Box>
      )
    },
  },
  {
    id: 2,
    Header: 'Effective on',
    accessor: 'effective_date',
    Cell: (props) => {
      const { value } = props
      return (
        <Box p={2}>
          <Typography>{value}</Typography>
        </Box>
      )
    },
  },
  {
    id: 3,
    Header: 'Payroll type',
    accessor: 'payroll_type',
    Cell: (props) => {
      const { value } = props
      return (
        <Box p={2}>
          <Typography>{value}</Typography>
        </Box>
      )
    },
  },
  {
    id: 4,
    Header: 'Employee',
    accessor: 'employee_number',
    Cell: ({ value }) => (
      <Box p={2}>
        <Typography>{`${value} (employee)`}</Typography>
      </Box>
    ),
  },
  {
    id: 5,
    Header: 'Net Pay',
    accessor: 'nett_salary',
    Cell: (props) => {
      const { value, column } = props
      return (
        <Box p={2}>
          <Typography sx={{ fontWeight: column.Header === 'Net Pay' && 600 }}>{value}</Typography>
        </Box>
      )
    },
  },
]

const PayrollHistory = () => {
  const navigate = useNavigate()
  const [selectValue, setSelectValue] = useState('') // can contain either '' OR '2024'
  // const [filteredData, setFilteredData] = useState([])
  const handleSetSelectValue = (event) => {
    setSelectValue(event.target.value)
  }
  const { data: historyData, isLoading } = useQuery(
    ['getHistory', selectValue],
    async () => {
      const { data } = await retrieveHistory(selectValue)
      return data
    },
    {
      onError: (err) => Bugsnag.notify(err),
    }
  )

  const { data: historyDropdown } = useQuery(
    'historyDropdown',
    async () => {
      const data = await getHistoryYear()
      return data.reverse()
    },
    {
      onError: (err) => Bugsnag.notify(err),
    }
  )

  const newFunc = (item) => {
    navigate(`/app/payroll/payroll-history/${item?.month_word}-${item?.year}`, {
      state: item?.time_id,
    })
  }

  useEffect(() => {
    if (historyDropdown) {
      if (historyDropdown?.length !== 0) {
        setSelectValue(historyDropdown[0]?.year)
      } else {
        setSelectValue('')
      }
      return
    }
    return
  }, [historyDropdown])

  return (
    <DashboardContainer headerTitle="Payroll History">
      <Box>
        {isLoading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{
              backgroundColor: 'white.main',
              borderRadius: 2,
              height: { xs: 'calc(100vh - 200px)', lg: 'calc(100vh - 235px)' },
              boxShadow: 'none',
            }}
          >
            <CircularProgress color="alternate" size={60} />
          </Box>
        )}
        {!historyData || historyData?.length === 0 ? (
          <Box sx={{ border: '1px solid', borderColor: 'gray-line.main', borderRadius: '4.5px' }}>
            <AdxEmptyStateV2
              icon={<Icon>account_balance</Icon>}
              title="No Payroll History Found"
              subtitle="Please proceed to run the payroll. The history of payroll will be displayed here after it has exceed the effective date"
              height={400}
            />
          </Box>
        ) : (
          <>
            <Box
              display={{ xs: 'flex', lg: 'block' }}
              sx={{
                justifyContent: { xs: 'space-between', lg: 'none' },
                alignItems: { xs: 'center' },
              }}
            >
              <AdxDropdown
                sx={{
                  width: '250px',
                  marginBottom: '20px',
                  '& .MuiOutlinedInput-root': {
                    maxHeight: '45px',
                    outline: 'none',
                    backgroundColor: 'white.main',
                  },
                  '& .MuiSelect-select': {
                    padding: '0px 14px',
                  },
                }}
                value={selectValue}
                disabled={historyDropdown?.length === 0}
                onChange={handleSetSelectValue}
              >
                {historyDropdown?.length !== 0 ? (
                  historyDropdown?.map((year, index) => (
                    <AdxMenuItem key={index} value={year.year} selectedvalue={selectValue}>
                      {year.year}
                    </AdxMenuItem>
                  ))
                ) : (
                  <AdxMenuItem disabled selectedvalue={null}>
                    You have no payroll history at the moment
                  </AdxMenuItem>
                )}
              </AdxDropdown>
            </Box>
            <Box
              sx={{
                boxShadow: 'none',
                border: 1,
                borderRadius: '4.5px',
                borderColor: 'gray-line.main',
                overflow: 'hidden',
              }}
            >
              <AdxTableV2
                column={col}
                data={historyData}
                nav="View"
                onClick={newFunc}
                sxNav={{ textDecoration: 'underline' }}
                allColumnSorted={false}
                rowClickable
                highlightWhenHovered
                stickyHeader
                stickyFirstColumn
                height={'calc(100vh - 200px)'}
              />
            </Box>
          </>
        )}
        {/* {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            backgroundColor: 'white.main',
            borderRadius: 2,
            height: { xs: 'calc(100vh - 200px)', lg: 'calc(100vh - 235px)' },
            boxShadow: 'none',
          }}
        >
          <CircularProgress color="alternate" size={60} />
        </Box>
      ) : !filteredData || filteredData?.length === 0 ? (
        <NoData
          icon="account_balance"
          title="No Payroll History Found"
          description={
            'Please proceed to run the payroll. The history of payroll will be displayed here after it has exceed the effective date'
          }
        />
      ) : (
        <AdxTableComponent
          column={col}
          data={filteredData}
          nav="View"
          onClick={newFunc}
          sx={{
            height: { xs: 'calc(100vh - 200px)', lg: 'calc(100vh - 235px)' },
            boxShadow: 'none',
          }}
          sxNav={{ textDecoration: 'underline' }}
        />
      )} */}
      </Box>
    </DashboardContainer>
  )
}

export default PayrollHistory
